import SubmittedCollections from './SubmittedCollection';

export default SubmittedCollections;
